import { TableSchema } from '../metadata-schema';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { vest_cluster_vso } from './vest_cluster_vso';
import { IndicatorNaamPrestatieanalyse } from '../enums/IndicatorNaamPrestatieanalyse';

export const fac_pv_prestatieanalyse_vso: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_pv_prestatieanalyse_vso",
	"description": "Definitie voor fact tabel fac_pv_prestatieanalyse_vso uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Instellingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"properties": {
		"pv_fk_vs": {
			"include": [
				"vs_nm_vestiging"
			],
			"descriptionOverride-somtoday": {
				"vs_nm_vestiging": "De vestiging waar deze score betrekking op heeft. Er is aangenomen dat de vestigingen in Somtoday overeenkomen met\nde OKE's (onderwijskundige eenheden) waar de inspectie naar kijkt."
			},
			"descriptionOverride-magister": {
				"vs_nm_vestiging": "De locatie waar deze score betrekking op heeft. Er is aangenomen dat de locaties in Magister overeenkomen met\nde OKE's (onderwijskundige eenheden) waar de inspectie naar kijkt."
			},
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"pv_fkd_vcv": {
			"description": "Definitie voor sys tabel vest_cluster_vso uit de CumLaude DWH",
			"type": "object",
			"schema": vest_cluster_vso
		},
		"pv_nm_indicator": {
			"label": "Indicator",
			"category": "Prestatieanalyse",
			"example": "Behaald niveau conform OPP, Beoogd i.r.t. behaald einduitstroomniveau, ...",
			"filter": false,
			"grouping": false,
			"exportable": true,
			"description": "De indicator binnen de prestatieanalyse zoals opgesteld door de inspectie waarop deze score betrekking heeft:\n- Behaald niveau conform OPP: De score is het percentage leerlingen die zijn uitgestroomd op het niveau\nzoals beoogd in het ontwikkelingsperspectief (OPP). Hiertoe moeten het veld Beoogd uitstroomniveau in het OPP\ngevuld zijn en het veld Behaald uitstroomniveau bij de uitschrijving. Beide niveaus worden vergeleken op basis\nvan de door de inspectie toegekende punten (5-11,5), dus niveaus met gelijke punten worden gezien als equivalent.\nHet gaat uitsluitend om einduitstroom-leerlingen: leerlingen die de opleiding met diploma verlaten.  \n- Beoogd i.r.t. behaald einduitstroomniveau: De score is het gemiddelde absolute verschil tussen de puntenaantallen\nvan het behaalde en het in het OPP beoogde uitstroomniveau. Hiertoe moeten het veld Beoogd uitstroomniveau in het OPP\ngevuld zijn en het veld Behaald uitstroomniveau bij de uitschrijving.\nHet gaat uitsluitend om einduitstroom-leerlingen: leerlingen die de opleiding met diploma verlaten.\n- Tussentijdse uitstroom: het percentage leerlingen die tussentijds (d.w.z. zonder diploma) uitstromen naar regulier\n(niet-speciaal) onderwijs ten opzichte van alle leerlingen die tussentijds uitstromen naar een andere school.\nLeerlingen die uitstromen met een uitstroomniveau van het type Arbeid worden hierbij niet meegerekend.\n- Einduitstroom: het percentage leerlingen die uitstromen met een uitstroomniveau van het type Vervolgonderwijs\nten opzichte van alle leerlingen die uitstromen. Hiertoe moet het veld Behaald uitstroomniveau bij de uitschrijving\nzijn vastgelegd. Het gaat uitsluitend om einduitstroom-leerlingen: leerlingen die de opleiding met diploma verlaten.",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": IndicatorNaamPrestatieanalyse
		},
		"pv_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"category": "Prestatieanalyse",
			"example": "2023/2024",
			"description": "Het schooljaar waarop deze score betrekking heeft.",
			"filter": true,
			"grouping": false,
			"exportable": true,
			"blocklist": {
				"geenVSO": true
			}
		},
		"pv_nr_score": {
			"type": "number",
			"label": "Score",
			"category": "Prestatieanalyse",
			"example": "0-100",
			"filter": false,
			"grouping": false,
			"exportable": true,
			"description": "De score die deze vestiging heeft behaald voor deze indicator. Zie de beschrijving van het veld Indicator voor de betekenis van de score.",
			"blocklist": {
				"geenVSO": true
			}
		}
	}
};
